import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";

export const StandardVideoElementMixin = {
  extends: DynamicElementMixin,
};
